// This file is automatically generated from "/scripts/generate-component-imports.js". Do not edit.

require('../components/knockout/article-list/index.js');
require('../components/knockout/checkout-course-list/index.js');
require('../components/knockout/checkout-overview-page/index.js');
require('../components/knockout/choose-payer/index.js');
require('../components/knockout/date-time-list/index.js');
require('../components/knockout/digital-signing-order-form/index.js');
require('../components/knockout/loader/index.js');
require('../components/knockout/media-tile/index.js');
require('../components/knockout/my-courses-block/index.js');
require('../components/knockout/purchase-button/index.js');
require('../components/knockout/quick-purchase-button/index.js');
require('../components/knockout/read-more-popup/index.js');
require('../components/knockout/register-continue-button/index.js');
require('../components/knockout/shopping-cart/index.js');
require('../components/knockout/submit-button/index.js');
require('../components/knockout/tooltip/index.js');
require('../components/knockout/video-course-receipt/index.js');
require('../components/knockout/youtube-video/index.js');
